import { wagmiConfig } from '@shared/configs/wagmi-config';
import { payWithPowerAbi } from 'api/abis/payWithPower.abi';
import { ethers } from 'ethers';
import { useCallback } from 'react';
import { useWriteContract } from 'wagmi';
import { waitForTransactionReceipt } from 'wagmi/actions';

export interface PowerOrder {
  orderId: string
  validUntil: number | bigint
  price: number | bigint
  signature: string
}

const usePayWithPower = () => {
  const { writeContractAsync } = useWriteContract({ config: wagmiConfig });

  const payWithPower = useCallback(
    async ({
      orderId, price, validUntil, signature,
    }: PowerOrder) => {
      try {
        const hash = await writeContractAsync({
          address: import.meta.env.VITE_CONTRACT_ADDRESS,
          abi: payWithPowerAbi,
          functionName: 'payWithPower',
          args: [
            {
              orderId: ethers.encodeBytes32String(orderId) as `0x${string}`,
              validUntil: BigInt(validUntil),
              price: BigInt(price),
            },
            signature as `0x${string}`,
          ],
        });

        const transactionReceipt = await waitForTransactionReceipt(wagmiConfig, {
          hash,
        });

        if (transactionReceipt.status !== 'success') {
          throw new Error('Transaction failed');
        }

        return hash;
      } catch (error) {
        console.error('Transaction failed:', error);
        throw error;
      }
    },
    [writeContractAsync],
  );

  return { payWithPower };
};

export default usePayWithPower;
